import React from 'react';
import { Box } from '@mui/material';

import CommandBarWidget from './CommandBarWidget/CommandBarWidget';
import floatingPanelEngine from './Core/FloatingPanelEngine';
import commandEngine from './CommandBarWidget/Commands/CommandEngine';
import cardPainterManager from '../../../Widgets/DataPainterWidget';

/**
 * YourLibraryTabPainter — pure painter.
 * Renders CommandBarWidget + all open CardPainterManager cards.
 * FloatingContentPanel instances are painted by JxWindowManager in PageContent.
 */
const YourLibraryTabPainter = React.memo(function YourLibraryTabPainter() {
    const [, forceRepaint] = React.useState(0);

    React.useEffect(() => {
        cardPainterManager.registerPainter(() => forceRepaint((c) => c + 1));
    }, []);

    function handleCommand(cmd) {
        if (commandEngine.execute(cmd)) return;
        floatingPanelEngine.openPanel(cmd, cmd);
    }

    return (
        <Box id="your-library-root">
            <CommandBarWidget open={true} onCommand={handleCommand} />
            {cardPainterManager.paint()}
        </Box>
    );
});

export default YourLibraryTabPainter;
